import React from 'react';

export const WhiteHeartIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Cut outline S / Navigation / Caret down">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1981 3C14.6851 3 13.1821 3.559 12.0301 4.676L12.0001 4.705L11.9691 4.676C10.8171 3.559 9.31411 3 7.80111 3C6.33711 3 4.88211 3.523 3.75411 4.569C1.34211 6.808 1.46811 10.701 3.82111 13.002L12.0001 21L20.1791 13.002C22.5311 10.701 22.6581 6.808 20.2451 4.569C19.1181 3.523 17.6631 3 16.1981 3ZM16.1981 5C17.2111 5 18.1651 5.368 18.8851 6.036C19.5911 6.69 19.9861 7.607 19.9991 8.617C20.0141 9.723 19.5701 10.8 18.7811 11.572L12.0001 18.203L5.21911 11.572C4.43011 10.8 3.98611 9.723 4.00011 8.617C4.01311 7.607 4.40911 6.69 5.11511 6.036C5.83411 5.368 6.78811 5 7.80111 5C8.85211 5 9.83811 5.395 10.6011 6.135L12.0241 7.467L13.4221 6.111C14.1611 5.395 15.1471 5 16.1981 5Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
